import React, { FC, Fragment, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'

import { ButtonMUI } from 'components/ButtonMUI'
import { Modal } from 'components/Modal'
import { InputField } from 'components/InputField'
import { TextareaField } from 'components/TextareaField'

import { toast } from 'react-toastify'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
// import ReCAPTCHA from 'react-google-recaptcha'
import { useMediaQuery } from 'utils/hooks'
import { IJoinAlpha } from 'models'

import styles from './styles.module.scss'

export interface IRequestAccessForm {
  name: string;
  email: string;
  link: string;
  note?: string
}

const schema = yup.object().shape({
  name: yup.string().required('Name should be required please'),
  email: yup.string().email().required('Email should be required please'),
  link: yup.string().url().required('Portfolio or Personal Link should be required please'),
  note: yup.string().max(500, 'Max length 500 symbols').optional()
})

interface IProps {
  open: boolean,
  onClose: () => void,
}

export const AccessAlphaModal: FC<IProps> = ({ open, onClose }) => {
  const { loadingStore, accountStore } = useStore()
  // const width_360 = useMediaQuery('(max-width: 360px)')

  const { control, handleSubmit, formState: { errors }, reset } = useForm<IRequestAccessForm>({
    resolver: yupResolver(schema)
  })

  // const onChange = (value: string | null) => {
  //   if (value) {
  //     console.log('value', value)
  //   }
  // }

  const onSubmit = async (data: IRequestAccessForm) => {
    try {
      console.log('data', data)
      loadingStore.setLoading(true)
      const reserveData: IJoinAlpha = {
        Name: data.name,
        Email: data.email,
        PersonalLink: data.link,
        Note: data.note || ''
      }
      await accountStore.sendRequestToAlpha(reserveData)
      toast.success('You have successfully made a Request to Join 3.0 Alpha')
      reset()
      onClose()
    } catch (error: any) {
      toast.error(error.message ?? 'Something went wrong. Please try again')
      console.log('error', error)
    } finally {
      loadingStore.setLoading(false)
    }
  }

  return (
    <Modal open={open}
           onClose={onClose}
           scroll={'paper'}
           maxWidth={'md'}
           contentSX={{ '&&': { paddingTop: '25px', maxWidth: '675px' } }}
           title={<>Request Access to Join the Alpha Testing for Somnium&nbsp;v3.0</>}
           subTitle={'We\'re thrilled that you\'re interested in joining the alpha testing of Somnium v3.0! Please tell us more about yourself and how you can contribute to our vibrant community. Your insights and creativity are valuable to us. Together, let\'s shape the future of Somnium Space!'}
    >
      <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
        <div className={styles.inputsBlock}>
          <div className={styles.nameEmailBox}>
            <InputField name={'name'} placeholder={'Name*'} control={control} errors={errors}/>
            <InputField name={'email'} placeholder={'Email Address*'} control={control} errors={errors}/>
          </div>
          <div className={styles.linkBox}>
            <InputField name={'link'} placeholder={'Portfolio or Personal Link*'} control={control} errors={errors}/>
          </div>
          <div className={styles.noteBox}>
            <TextareaField name={'note'} control={control} errors={errors} placeholder={'Leave a note'}/>
          </div>

          <div className={styles.submitBox}>
            {/*<ReCAPTCHA*/}
            {/*  type={'image'}*/}
            {/*  size={width_360 ? 'compact' : 'normal'}*/}
            {/*  theme={'light'}*/}
            {/*  onChange={onChange}*/}
            {/*  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''}*/}
            {/*/>*/}
            <ButtonMUI styleType={'blue'}
                       type="submit"
              // disabled={disabledButton}
            >
              Want to Join
            </ButtonMUI>
          </div>
        </div>
      </form>
    </Modal>
  )
}
